export default "__VITE_ASSET___NzcChLn__"